import 'twin.macro';
import { AccountTeacher } from '@teetsh/app/src/containers/Director/Settings/AccountTeacher';
import { RemoveAccount } from '@teetsh/app/src/containers/Director/Settings/RemoveAccount';
import { GeneralInfos } from '@teetsh/app/src/containers/UserSettings/Compte/GeneralInfos';
import React from 'react';
import { useUserAccount } from '@teetsh/app/src/queries/user/account/useUserAccount';
import SpinnerComponent from '@teetsh/app/src/components/Spinner/ScreenSpinner';

export function Compte() {
  const { isLoading, data: userAccount } = useUserAccount();

  if (isLoading || !userAccount) {
    return <SpinnerComponent />;
  }

  return (
    <>
      <GeneralInfos userAccount={userAccount} />
      <AccountTeacher />
      <RemoveAccount />
    </>
  );
}
